import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'set_tiles_synced',
  stateProp: 'tilesSynced',
  defaultState: {
    tilesSynced: false
  },
  handler() {
    return { tilesSynced: true };
  },
  reduce(state, { tilesSynced }) {
    return { tilesSynced };
  }
});
